import React, { useEffect, useState } from 'react';
import { Card, Switch, Space, Collapse, Spin, Button, Table, Tag } from 'antd';
import { ArrowLeftOutlined, InsertRowLeftOutlined, EditOutlined } from '@ant-design/icons'
import { useParams, Link } from 'react-router-dom';
import "swagger-ui-react/swagger-ui.css";
import { getApiDocDetail, updatePrivacyApiDocs } from '../../../apis/apiDocs';
import { getApisList, updatePrivacyApis } from '../../../apis/apis';
import AdminLayoutWrapper from '../AdminLayoutWrapper';
import MethodTag from '../../Method';

const { Panel } = Collapse;

const ApiDocDetail = () => {

  const [apiDocDetail, setDetail] = useState({});
  const [apiList, setApiList] = useState([]);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  const fetchApis = async (id) => {
    try {
      const docListRes = await getApisList(id);
      setApiList(docListRes)
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    const fetchApiDocDetail = async () => {
      try {
        if (id ?? false) {
          setLoading(true);
          const servieDetailRes = await getApiDocDetail(id);
          await fetchApis(id);
          setDetail(servieDetailRes);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    }
    fetchApiDocDetail();
  }, [id]);

  const updateScope = async (nextValue, group, targetId) => {
    try {
      setLoading(true);

      if (group === 'api-docs') {
        await updatePrivacyApiDocs(id, {
          public: nextValue,
        });
        const servieDetailRes = await getApiDocDetail(id);
        setDetail(servieDetailRes);
      } else if (group === 'apis') {
        await updatePrivacyApis(targetId, {
          public: nextValue
        });
        const nextApiList = apiList.map((doc) => {
          if (parseInt(doc.id) === parseInt(targetId)) {
            console.log(doc.id, targetId);
            return {
              ...doc,
              isPublic: nextValue,
            }
          }
          return doc;
        });
        setApiList(nextApiList);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  const columns = [
    {
      title: 'Path',
      dataIndex: 'path',
      key: 'path',
      width: 300,
      render: (value, row) => {
        return (<div>
          <a target="_blank" rel="noopener noreferrer" href={`/admin/apis/${row.id}`}>{value}</a>
        </div>)
      }
    },
    {
      title: 'Method',
      dataIndex: 'method',
      key: 'method',
      width: 100,
      render: (value) => {
        return <div><MethodTag method={value} /></div>
      }
    }, {
      title: 'External Path',
      dataIndex: 'externalPath',
      key: 'externalPath',
      width: 300,
    },
    {
      title: 'Status',
      dataIndex: 'isPublic',
      key: 'status',
      width: 100,
      render: (value, row) => {
        return (<div>
          <Switch
            checkedChildren="Public"
            unCheckedChildren="Private"
            defaultChecked={false}
            checked={value}
            onChange={(checked) => {
              updateScope(checked, 'apis', row.id)
            }}
          /></div>)
      }
    },
    {
      title: 'Scope',
      dataIndex: 'scopes',
      key: 'scopes',
      width: 200,
      render: (value) => {
        return (<div>
          {
            value && value.map((scope) => {
              return (
                <Tag color="default" style={{ marginRight: 3 }}>{scope.scopeId}</Tag>
              )
            })
          }
        </div>)
      }
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (value, row) => {
        return (
          <div>
            <a target="_blank" rel="noopener noreferrer" href={`/admin/apis/${row.id}`}>
              <Button
                type="primary"
                icon={<EditOutlined />}
              >
                Edit
              </Button>
            </a>
          </div>)
      }
    }
  ];


  return (
    <AdminLayoutWrapper>
      <Spin spinning={loading}>
        <div>
          <Button type="primary" size="large">
            <Link to={`/admin/services/${apiDocDetail?.serviceEntryId}`}><ArrowLeftOutlined /> Back</Link>
          </Button>
        </div>
        <br />
        <div>
          {
            apiDocDetail?.name &&
            (<div>
              <Card title={apiDocDetail.name}>
                <div>
                  <Space>
                    <p>Status:</p>
                    <p>
                      <Switch
                        checkedChildren="Public"
                        unCheckedChildren="Private"
                        defaultChecked={false}
                        checked={apiDocDetail.public}
                        onChange={(checked) => {
                          updateScope(checked, 'api-docs')
                        }}
                      />
                    </p>
                  </Space>
                </div>
                <div>
                  <Space>
                    <p>Title:</p>
                    <p>
                      {apiDocDetail.title}
                    </p>
                  </Space>
                </div>
                <div>
                  <Space>
                    <p>Description:</p>
                    <p>
                      {apiDocDetail.description}
                    </p>
                  </Space>
                </div>
              </Card>
            </div>)
          }
        </div>

        <Card title="All Apis">
          <div>
            <Table
              width="100%"
              columns={columns}
              dataSource={apiList || []}
              bordered
              scroll={{ y: '100%' }}
            />
          </div>
        </Card>
      </Spin>
    </AdminLayoutWrapper>
  )
}


export default ApiDocDetail;